import {
  CheckCircleOutlined,
  EnvironmentOutlined,
  HomeOutlined,
  RadiusSettingOutlined,
  TagOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Fragment } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BiBed } from "react-icons/bi";

export const RoomInfo = (props) => {
  const { branding, room, handleShow } = props;
  const { t } = useTranslation();
  const customParagraphStyle = {
    color: branding.paragraphColor,
    fontFamily: branding.paragraphFont,
  };
  return (
    <Fragment>
      <p>
        <RadiusSettingOutlined />
        <strong>{t("room.room_size")}:</strong>
        <span style={customParagraphStyle}>{room.roomsize} sq meter</span>
      </p>
      <p>
        <TagOutlined /> <strong>{t("room.room_type")}:</strong>
        <span style={customParagraphStyle}>{room.type}</span>
      </p>
      <p>
        <EnvironmentOutlined /> <strong>{t("room.view")}:</strong>
        <span style={customParagraphStyle}>{room.roomview}</span>
      </p>
      <p>
        <BiBed />
        <strong>{t("room.bedding")}:</strong>
        <span style={customParagraphStyle}>{room.bedding}</span>
      </p>
      <div className="d-flex flex-wrap ">
        <p className="me-3">
          <UserOutlined />
          <strong>{t("room.max_adults")}:</strong>
          <span style={customParagraphStyle}> {room.maxadult}</span>
        </p>
        <p className="me-3">
          <TeamOutlined />
          <strong>{t("room.max_children")}:</strong>
          <span style={customParagraphStyle}> {room.maxchild}</span>
        </p>
        <p>
          <CheckCircleOutlined /> <strong>{t("room.extra_bed")}:</strong>
          <span style={customParagraphStyle}>
            {" "}
            {room.extrabed ? "Yes" : "No"}
          </span>
        </p>
      </div>
      <p>
        <HomeOutlined /> <strong>{t("room.facilities")}:</strong>
        <span style={customParagraphStyle}>
          {room.facilities.slice(0, 6).join(", ")}
          {room.facilities.length > 6 && "..."}
        </span>
      </p>
      <Button
        className="apply-button mb-3"
        style={{
          backgroundColor: branding.buttonColor,
          borderColor: branding.buttonColor,
        }}
        onClick={handleShow}
      >
        {t("room.details")}
      </Button>
    </Fragment>
  );
};
